import { ApiResponse, ApiResponseNonNull, mapDataNonNull } from '@/app/shared/http';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getApiEndpoint } from '../../http';

@Injectable({
  providedIn: 'root',
})
export class MixpanelService {
  private readonly http = inject(HttpClient);

  goToMixpanel(): Observable<ApiResponseNonNull<{link: string}>> {
    return this.http
      .get<ApiResponse<{ link: string }>>(getApiEndpoint('mixpanel'))
      .pipe(mapDataNonNull(res=>({link: res.link})));
  }
}
